import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MDTHeaderToolbar from './header-toolbar/headerToolbar.js';
import * as headerActions from '../../../actions/headerActions.js';

export const MDTNavigation = (props) => {
    return (
        <>
            <MDTHeaderToolbar {...props} />
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(headerActions, dispatch),
    };
};

export default connect(mapDispatchToProps)(MDTNavigation);
